import axiosPost from "./axiosPost";

export const RNHUnidadDel = async (credentials, data) => {
    const body = {
        service: "RNHUnidadDel",
        params: {
            rnhUnidadId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
